<template>
  <div class="campaign-banner" v-if="isVisible">
    <a 
      href="https://causematch.com/Lamdeini" 
      target="_blank" 
      rel="noopener noreferrer"
      class="banner-link"
    >
      <div class="banner-content">
        <div class="campaign-text">
          <span class="campaign-title">Give Every Boy a Chance at One-on-One Learning</span>
          <span class="campaign-separator">|</span>
          <span class="countdown">
            <span class="countdown-item">
              <strong>{{ days }}</strong> Days
            </span>
            <span class="countdown-item">
              <strong>{{ hours }}</strong> Hours
            </span>
            <span class="countdown-item">
              <strong>{{ minutes }}</strong> Minutes
            </span>
            <span class="countdown-item">
              <strong>{{ seconds }}</strong> Seconds
            </span>
          </span>
        </div>
        <button class="donate-button">Donate Now →</button>
      </div>
    </a>
    <button class="close-banner" @click="closeBanner" aria-label="Close banner">
      ✕
    </button>
  </div>
</template>

<script>
export default {
  name: "CampaignBanner",
  data() {
    return {
      isVisible: false, // Campaign ended - set to true to re-enable
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      endDate: new Date('Fri Nov 28 2025 07:00:00 GMT+0200'),
      intervalId: null,
    };
  },
  mounted() {
    // Update countdown immediately
    this.updateCountdown();
    
    // Update every second
    this.intervalId = setInterval(() => {
      this.updateCountdown();
    }, 1000);

    // Add class to body to offset top-nav only if banner is visible
    if (this.isVisible) {
      document.body.classList.add('campaign-banner-visible');
    }
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    // Remove class when component is destroyed
    document.body.classList.remove('campaign-banner-visible');
  },
  methods: {
    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.endDate.getTime() - now;

      if (distance < 0) {
        // Campaign has ended
        this.days = 0;
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        this.isVisible = false;
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
    },
    closeBanner() {
      this.isVisible = false;
      // Remove the top-nav offset when banner is closed
      document.body.classList.remove('campaign-banner-visible');
    },
  },
};
  </script>
  
<style>
/* Push the top-nav below the campaign banner only when banner is visible */
body.campaign-banner-visible .top-nav {
  top: 60px !important;
}
</style>

<style scoped>

.campaign-banner {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #113740 0%, #1a5360 100%);
  color: white;
  padding: 12px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: slideDown 0.5s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.banner-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
  gap: 20px;
}

.campaign-text {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  flex: 1;
}

.campaign-title {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.campaign-separator {
  font-size: 18px;
  opacity: 0.6;
}

.countdown {
  display: flex;
  gap: 15px;
  align-items: center;
}

.countdown-item {
  font-size: 14px;
  font-weight: 400;
}

.countdown-item strong {
  font-size: 20px;
  font-weight: 700;
  margin-right: 3px;
}

.donate-button {
  background: white;
  color: #1a5360;
  border: none;
  padding: 10px 24px;
  border-radius: 25px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.donate-button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(255, 255, 255, 0.3);
}

.close-banner {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.close-banner:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .campaign-banner {
    padding: 10px 15px;
  }

  .banner-content {
    flex-direction: column;
    gap: 12px;
    padding-right: 30px;
  }

  .campaign-text {
    flex-direction: column;
    gap: 10px;
    align-items: center;
    text-align: center;
  }

  .campaign-title {
    font-size: 16px;
  }

  .campaign-separator {
    display: none;
  }

  .countdown {
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .countdown-item {
    font-size: 12px;
  }

  .countdown-item strong {
    font-size: 16px;
  }

  .donate-button {
    padding: 8px 20px;
    font-size: 14px;
  }

  .close-banner {
    top: 10px;
    right: 10px;
    transform: none;
  }
}

@media (max-width: 480px) {
  .campaign-title {
    font-size: 14px;
  }

  .countdown-item {
    font-size: 11px;
  }

  .countdown-item strong {
    font-size: 14px;
  }
}
</style>

